import { FormattedMessage } from "react-intl";
import "./Footer.scss";

const year = new Date().getFullYear();

const menuItems: { link: string; intlKey: string; values?: Record<string, string | number> }[] = [
  {
    link: "https://sportradar.com/",
    intlKey: "footer.sportradar.link",
    values: { item: year },
  },
  {
    link: "https://sportradar.com/contact/",
    intlKey: "contact",
  },
  {
    link: "https://support.synergysports.com/support/solutions/folders/77000328001",
    intlKey: "support",
  },
  {
    link: "https://sportradar.com/single-sign-on-sso-privacy-notice/",
    intlKey: "privacy",
  },
  {
    link: "https://sportradar.com/imprint/",
    intlKey: "terms",
  },
];

export const Footer = () => {
  return (
    <div className="app-footer">
      {menuItems.map(({ link, intlKey, values }) => (
        <a key={link} href={link} target="_blank" rel="noreferrer">
          <FormattedMessage id={intlKey} values={values} />
        </a>
      ))}
    </div>
  );
};
